import { defineMessages } from 'react-intl'

export default defineMessages({
  copyright: {
    id: 'footer.copyright',
    defaultMessage: 'copyright Blok A3 d.o.o.',
  },
  ppLink: {
    id: 'footer.privacyPolicy',
    defaultMessage: 'Politika privatnosti',
  },
})
